import { createContext } from 'react';

// True inside the SSR page shell (src/pages/_shared/BookablePage.tsx), where
// each page's Vike `+Head.tsx` already server-renders every <title>, <meta>
// and <link> tag - with the real runtime config (process.env.APP_*).
// PageMeta renders nothing there: during SSR it can only see appConfig's
// defaults (e.g. APP_STAGE 'dev'), and React 19 hoists whatever it renders
// into the document <head>, so it produced a second, conflicting set of
// tags (EM-1183). In the client-only app (App.tsx) nothing provides this,
// so PageMeta keeps managing the head on client-side navigation.
export const HeadOwnedByServerContext = createContext(false);
